var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.7151,
    cy: 50.8751,
    r: 50,
    fill: "",
    className: "fillWithPrimaryColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0044 29.5589C33.4238 29.4447 33.8651 29.3838 34.3206 29.3838H66.2324C68.9938 29.3838 71.2324 31.6224 71.2324 34.3838V68.2435C71.2324 68.699 71.1714 69.1403 71.0573 69.5597C73.1802 68.9819 74.7411 67.0406 74.7411 64.7347V30.8751C74.7411 28.1136 72.5026 25.8751 69.7411 25.8751H37.8294C35.5235 25.8751 33.5822 27.436 33.0044 29.5589Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.689 37.0154C26.689 34.254 28.9276 32.0154 31.689 32.0154H63.6008C66.3622 32.0154 68.6008 34.254 68.6008 37.0154V70.8751C68.6008 73.6365 66.3622 75.8751 63.6008 75.8751H31.689C28.9276 75.8751 26.689 73.6365 26.689 70.8751V37.0154Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5599 40.0989L61.326 45.865L59.2155 53.7428L51.3377 55.8533L45.5716 50.0872L47.6822 42.2095L55.5599 40.0989ZM43.4254 49.9413L38.2545 51.3268L34.4686 47.5411L35.8545 42.3697L41.0253 40.9841L44.8113 44.7698L43.4254 49.9413ZM33.9638 62.0256L39.7299 67.7917L47.6077 65.6811L49.7182 57.8034L43.9521 52.0373L36.0744 54.1478L33.9638 62.0256ZM51.8644 57.9494L57.0353 56.5639L60.8212 60.3496L59.4353 65.521L54.2645 66.9066L50.4786 63.1209L51.8644 57.9494Z",
    fill: "",
    className: "fillWithPrimaryColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.e3777ff7b8d4a0539ee6efe0e1ea7728.svg";
export { ForwardRef as ReactComponent };